<div class="content-block library-teacher__paginate">
  <div
    class="personal-library-header flex flex-col sm:flex-row sm:items-center justify-center align-items-stretch gap-2"
  >
    <a class="mat-caption" href="#" (click)="showInfo($event)" i18n>What are My Units?</a>
    <span class="flex-1"></span>
    <select-tags [selectedTags]="selectedTags" (selectTagEvent)="selectTags($event)" />
    <mat-form-field [subscriptSizing]="'dynamic'">
      <mat-label i18n>View</mat-label>
      <mat-select [(ngModel)]="showArchivedView" (selectionChange)="switchActiveArchivedView()">
        <mat-option [value]="false" i18n>Active</mat-option>
        <mat-option [value]="true" i18n>Archived</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <mat-divider></mat-divider>
  <div class="flex flex-col items-center justify-start align-items-stretch gap-2 sm:flex-row">
    <div class="flex w-full sm:w-auto items-center sm:justify-center gap-1 order-1 sm:order-none">
      <select-all-items-checkbox
        [tooltip]="projectsLabel"
        [numAllItems]="numProjectsInView"
        [numSelectedItems]="numSelectedProjects()"
        (allSelectedEvent)="selectAllProjects()"
        (noneSelectedEvent)="unselectAllProjects()"
      ></select-all-items-checkbox>
      <span *ngIf="numSelectedProjects() > 0" class="secondary-text" i18n>
        {{ numSelectedProjects() }} selected
      </span>
      <archive-projects-button
        *ngIf="selectedProjects().length > 0"
        [showArchive]="!showArchivedView"
        (archiveProjectsEvent)="archiveProjects($event)"
      ></archive-projects-button>
      @if (selectedProjects().length > 0) {
        <apply-tags-button [selectedProjects]="selectedProjects()" />
      }
    </div>
    <span class="flex-1 hidden sm:flex"></span>
    <mat-paginator
      class="ml-auto"
      [length]="filteredProjects.length"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      (page)="pageChange($event)"
    >
    </mat-paginator>
  </div>
  <mat-divider></mat-divider>
  <div class="library__list flex flex-col flex-wrap items-start sm:flex-row">
    <ng-container *ngFor="let project of filteredProjects; let i = index">
      <app-library-project
        *ngIf="isOnPage(i)"
        [project]="project"
        [myUnit]="true"
        [checked]="projectIdToIsSelected()[project.id]"
        (projectSelectionEvent)="updateSelectedProjects($event)"
        class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4"
      />
    </ng-container>
    <div *ngIf="filteredProjects.length === 0" class="notice" i18n>
      No owned or shared units found.
    </div>
  </div>
  <mat-divider></mat-divider>
  <mat-paginator
    [length]="filteredProjects.length"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="pageChange($event, true)"
  >
  </mat-paginator>
</div>
